import { Method } from 'eurogard-pattern';
import { GetByFilterMethodParameter, GetByFilterMethodResponse } from 'eurogard-table-system';
import { inject, Injectable, Injector, INJECTOR } from '@angular/core';
import { FormType, RXAP_FORM_DEFINITION } from 'eurogard-forms';
import {
  DashboardControllerGetByAutocompleteRemoteMethod,
} from 'open-api-legacy/remote-methods/dashboard-controller-get-by-autocomplete.remote-method';
import {
  DashboardAutoCompleteResponseResponse,
} from 'open-api-legacy/responses/dashboard-auto-complete-response.response';

@Injectable()
export class TypedDashboardTableMethod implements Method<GetByFilterMethodResponse<DashboardAutoCompleteResponseResponse>, GetByFilterMethodParameter> {

  private readonly getByFilter        = inject(DashboardControllerGetByAutocompleteRemoteMethod);
  private readonly injector: Injector = inject(INJECTOR);

  async call({parameters}: GetByFilterMethodParameter): Promise<GetByFilterMethodResponse<DashboardAutoCompleteResponseResponse>> {

    const formDefinition = this.injector.get<FormType<{ type: number }>>(RXAP_FORM_DEFINITION);

    parameters.filter ??= '';
    if (parameters.filter) {
      parameters.filter += '%3B';
    }
    parameters.filter += [
      [ 'dashboardType', formDefinition.type.value ].join('%3A'),
      [ 'link', 'orgId' ].join('%3A'),
      [ 'subtype', '0' ].join('%3A'),
    ].join('%3B');

    const response = await this.getByFilter.call({parameters});
    return {
      ...response,
      entities: response.entities?.map(dashboard => ({
        ...dashboard,
        companyName: dashboard.company?.name ?? null,
        locationName: dashboard.location?.name ?? null,
      })) ?? [],
    };
  }

}
